@if (offer$ | async; as offer) {
  <div class="cash-out-container">
    <button
      [disabled]="disableCashOut() | async"
      (click)="handleSubmit(offer?.bets)"
      (mouseenter)="handleLivePnl($event, offer?.bets)"
      (mouseleave)="handleLivePnl($event, offer?.bets)">
      <span class="cash-out">
        Cashout&nbsp;<b>{{ offer.cashOut | number: "1.2-2" }}</b>
      </span>
      <span class="pnl">
        Profit&nbsp;<b [ngClass]="{ 'pnl-green': offer.profit >= 0, 'pnl-red': offer.profit < 0 }">{{ offer.profit | number: "1.2-2" }}</b>
      </span>
    </button>
    <!--    <div style="display: flex; flex-direction: column; gap: 4px; align-items: start; font-size: 15px">-->
    <!--      <ul>-->
    <!--        @if (cashOutService.conditions$ | async; as conditions) {-->
    <!--          @for (each of conditions; track each.label) {-->
    <!--            <li>{{ each.label }} - {{ each.value }}</li>-->
    <!--          }-->
    <!--            <li>Is Disabled - {{cashOutService.isCashOutDisabled}}</li>-->
    <!--        }-->
    <!--      </ul>-->
    <!--    </div>-->
    <table *featureFlag="'cashOutDebuggerTable'">
      <thead>
        <tr>
          <th colspan="4" style="text-align: center">Bets to be placed</th>
        </tr>
        <tr>
          <th>Selection</th>
          <th>Side</th>
          <th>Odds</th>
          <th>Stake</th>
        </tr>
      </thead>
      <tbody>
        @for (each of offer.bets; track each?.SELECTION_ID) {
          <tr>
            <td>{{ each?.runner }}</td>
            <td>{{ each?.SIDE }}</td>
            <td>{{ each?.PRICE }}</td>
            <td>{{ each?.SIZE | number: "1.2-2" }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
